import { __assign } from "tslib";
import * as React from 'react';
import { themes } from '../../ThemeOptions';
var BootStrapTh = React.lazy(function () {
    return import('../../bootstrap-table-components/components/BTTh');
});
var bootStrapTh = function (props) {
    return React.createElement(BootStrapTh, __assign({}, props));
};
export var Th = function (props) {
    var componentToDisplay = bootStrapTh(props);
    switch (props.ioTheme.uiLibrary) {
        case 'bootstrap':
            componentToDisplay = bootStrapTh(props);
    }
    return React.createElement(React.Fragment, null, componentToDisplay);
};
Th.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default Th;
//# sourceMappingURL=Th.js.map